import holidays from './holidays.json';
import { DateTime } from 'luxon';

const IsHoliday = () => {
  const today = DateTime.now().setZone('America/New_York');

  return holidays.some(holiday => {
    const holidayDate = DateTime.fromISO(holiday.date);
    return today.hasSame(holidayDate, 'day');
  });
};

export default IsHoliday;
